import { Link } from "react-router-dom";

interface DataDisclaimerProps {
  compact?: boolean;
  dark?: boolean;
}

const DataDisclaimer = ({ compact, dark }: DataDisclaimerProps) => {
  if (compact) {
    return (
      <p className={dark ? "text-xs text-alt-wht/50" : "text-xs text-alt-blk/55"}>
        Provisional catalog data. Some reports may be revised.{" "}
        <Link to="/about" className={dark ? "text-ray hover:text-sunset" : "text-turquoise hover:text-mars"}>
          About
        </Link>
      </p>
    );
  }

  return (
    <p className="leading-relaxed">
      These records come from published historical catalogs. They are{" "}
      <strong>provisional</strong> and likely to change. Repeat-illumination
      work by ALPO and BAA observers has shown that some reported events are
      the Moon’s normal appearance under that lighting, not a transient. We
      will revise this archive as those evaluations are published.
    </p>
  );
};

export default DataDisclaimer;
